// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-border {
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/v-sidebar/components/person-shortcut/person-shortcut.sidebar.component.sass"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ","sourcesContent":[".no-border\n    border: none !important"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
